/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IFormat {
  format: any;
  formatDispatch: any;
}

export enum AttioQueryKeys {
  USER_RECORD_ID = 'attio-user-record-id',
  NOTES = 'attio-notes',
  VALUATION_ITEM = 'attio-valuation-item',
  VALUATION_STATUS_OPTIONS = 'attio-valuation-status-options',
  CURRENT_VALUATIONS = 'attio-current-valuations',
  PAST_VALUATIONS = 'attio-past-valuations',
  VALUATIONS = 'attio-valuations',
  VALUATIONS_ALL = 'valuations-all',
  VALUATIONS_BATCH = 'valuations-batch',
  ADDITIONAL_DATA = 'additional-data',
}
